<script lang="ts">

  import { page } from "$app/state"
  import httpClient from "$lib/axios-client"
  import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle
  } from "$lib/components/ui/alert-dialog"
  import { type _response } from "$lib/data/type/_response"
  import LoaderCircleIcon from "@lucide/svelte/icons/loader-circle"
  import { createMutation } from "@tanstack/svelte-query"
  import { toast } from "svelte-sonner"

  const { open, setOpen, select, onDeleted }: {
    open: boolean
    setOpen: (value: boolean) => void | Promise<void>
    select: string
    onDeleted: () => void
  } = $props()

  const prefix = $derived(page.params.prefix ?? "0")

  const mutation = createMutation(() => ({
    mutationFn: async () => {

      const response = await httpClient.delete<_response<null>>(`/api/${prefix}/activity/unplans/${select}`)
      const responseData = response.data!

      if (response.status != 200) {
        throw new Error(responseData.message)
      }

      toast.success(responseData.message)

      setOpen(false)
      onDeleted()
    },
    onError: (error: Error) => {
      toast.error("Terjadi kesalahan", {
        description: error.message
      })
    }
  }))

</script>
<AlertDialog
  open={open}
  onOpenChange={setOpen}>
  <AlertDialogContent class="w-xs">
    <AlertDialogHeader>
      <AlertDialogTitle>Hapus</AlertDialogTitle>
      <AlertDialogDescription>
        Konfirmasi hapus data ini
      </AlertDialogDescription>
    </AlertDialogHeader>
    <AlertDialogFooter>
      <AlertDialogCancel
        disabled={mutation.isPending}>
        Batal
      </AlertDialogCancel>
      <AlertDialogAction
        class="group"
        data-loading={mutation.isPending}
        disabled={mutation.isPending}
        onclick={(event) => {
          event.preventDefault()
          mutation.mutate()
        }}>
        <span class="group-data-[loading=true]:invisible">Hapus</span>
        <LoaderCircleIcon class="group-data-[loading=true]:visible invisible absolute animate-spin"/>
      </AlertDialogAction>
    </AlertDialogFooter>
  </AlertDialogContent>
</AlertDialog>
